import {IOverride} from '../../index';

/**
 * Directional value pair for syncfield-style override panels
 * (`from` → `to`; restore flips overridden → original).
 */
export interface IOverrideValueComparison {
    fromLabelKey: string;
    toLabelKey: string;
    from: string;
    to: string;
}

/**
 * Duck-typed host for expanded override panels
 * ({@link component/override/override-details}).
 */
export interface IOverrideDetailsRow {
    isSavingOverrideDetails: KnockoutObservable<boolean>;
    overrideDetailsWaitMessage: string;
    isEditingOverrideComment: KnockoutObservable<boolean>;
    overrideCommentDraft: KnockoutObservable<string>;
    /** Bumped when the override snapshot is replaced or its comment is written in place. */
    overridePanelRevision: KnockoutObservable<number>;
    getOverride(): IOverride | null;
    overrideIdText(): string;
    overrideValueText(): string;
    overrideSyncImportFileIdText(): string;
    overrideCommentText(): string;
    overrideOverriddenWhen(): string;
    overrideOverriddenByName(): string;
    overrideDeletedWhen(): string;
    overrideDeletedByName(): string;
    isOverrideDeleted(): boolean;
    /**
     * Section heading — same CMS key as the status pill
     * (pending/synced / Modified / syncfield pending override, etc.).
     */
    getOverrideSectionHeadingKey(): string | null;
    /**
     * Optional original vs overridden value pair (syncfield source data).
     * When set, the panel shows a value comparison and omits the single value tag.
     */
    getOverrideValueComparison?(): IOverrideValueComparison | null;
    canEditOverrideComment(): boolean;
    startEditOverrideComment: () => void;
    cancelEditOverrideComment: () => void;
    submitOverrideComment: () => void;
}
